import { FieldValues, useController } from 'react-hook-form';

import { Stack } from '@mui/material';
import { BoxWithLabel } from 'common/components/BoxWithLabel';
import { FormFieldHint } from 'common/components/Inputs/FormFieldHint';

import { TextFieldProps } from '../TextField';
import { NumericControls } from './NumericControls';
import { StyledTextField } from './TextFieldWithLabel.styled';

type Props<T extends FieldValues> = TextFieldProps<T> & {
  showNumericControls?: boolean;
};

export const TextFieldWithLabel = <T extends FieldValues>({
  label,
  name,
  onChange,
  disabled,
  type,
  showNumericControls = type === 'number',
  ...textFieldProps
}: Props<T>) => {
  const {
    field,
    fieldState: { error },
  } = useController<T>({
    name,
  });

  const handleChange = (event: { target: { value: string } }) => {
    onChange?.(event.target.value);
    field.onChange(event);
  };

  return (
    <Stack>
      <BoxWithLabel label={label} height={48.13} disabled={disabled}>
        <Stack direction="row" justifyContent="space-between" alignItems="center" width="100%">
          <StyledTextField
            {...textFieldProps}
            {...field}
            type={type}
            disabled={disabled}
            variant="standard"
            value={field.value || ''}
            onChange={handleChange}
          />
          {showNumericControls && (
            <NumericControls
              value={field.value}
              onChange={handleChange}
              inputProps={textFieldProps.InputProps?.inputProps}
            />
          )}
        </Stack>
      </BoxWithLabel>
      <FormFieldHint error>{error?.message}</FormFieldHint>
    </Stack>
  );
};
